// Adaptador das rotas admin (/sftp-acesso/...) para a interface `api` dos
// componentes de components/AcessoSftp. Fica em arquivo próprio para os
// componentes não importarem o index (ciclo de import).
import {
  gerarNovaSenhaSftp,
  incluirChaveSftp,
  mensagemErro,
  mostrarSenhaSftp,
  removerChaveSftp,
} from "../../services/sftpAcessoApi";

export const acessoSftpAdminApi = {
  mostrarSenha: mostrarSenhaSftp,
  gerarNovaSenha: gerarNovaSenhaSftp,
  incluirChave: incluirChaveSftp,
  removerChave: removerChaveSftp,
  mensagemErro,
};
